import { render, staticRenderFns } from "./Labl.vue?vue&type=template&id=4a63afea&"
import script from "./Labl.vue?vue&type=script&lang=js&"
export * from "./Labl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports